import {
	DateTimeInput,
	Edit,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";

export const PartnerPayoutEdit = () => (
	<Edit>
		<SimpleForm>
			<TextInput source="id" disabled />
			<SelectInput
				source="status"
				choices={[
					{ id: "queued", name: "Queued" },
					{ id: "processing", name: "Processing" },
					{ id: "transfer_created", name: "Transfer Created" },
					{ id: "paid", name: "Paid" },
					{ id: "failed", name: "Failed" },
					{ id: "reversed", name: "Reversed" },
					{ id: "needs_attention", name: "Needs Attention" },
				]}
			/>
			<TextInput source="stripeTransferId" label="Stripe Transfer ID" />
			<TextInput source="lastError" label="Last Error" multiline />
			<DateTimeInput source="paidAt" label="Paid At" />
		</SimpleForm>
	</Edit>
);
